import React, { useState } from 'react';
import styled from 'styled-components';
import { Row } from 'styled/alignment/Row';
import colors from 'theme/colors';
import Fieldset from 'components/_UI/Fieldset';
import debounce from 'helpers/debounce';
import OrdersTable from './OrdersTable';
import { List, CheckCircle, Clock, XCircle, RotateCcw, AlertTriangle } from 'lucide-react';

export default function Orders() {
    const tabs = [
        { name: 'all', label: 'Todos', icon: List },
        { name: 'approved', label: 'Aprovados', icon: CheckCircle },
        { name: 'pending', label: 'Pendentes', icon: Clock },
        { name: 'canceled', label: 'Expirados', icon: XCircle },
        { name: 'refunded', label: 'Estornos', icon: RotateCcw },
        { name: 'chargeback', label: 'Chargeback', icon: AlertTriangle },
    ];

    const [selectedTab, setSelectedTab] = useState('all');
    const [search, setSearch] = useState('');

    const handleSearch = debounce((term) => {
        setSearch(term);
    }, 500);

    return (
        <Wrapper>
            <Tabs role="tablist">
                {tabs.map(el => {
                    const IconComponent = el.icon;
                    return (
                        <TabItem
                            key={el.name}
                            role="tab"
                            aria-selected={el.name === selectedTab}
                            selected={el.name === selectedTab}
                            onClick={() => setSelectedTab(el.name)}
                        >
                            <IconComponent size={15} />
                            <span>{el.label}</span>
                        </TabItem>
                    );
                })}
            </Tabs>

            <SearchRow>
                <Fieldset
                    placeholder="Pesquisar por nome, e-mail, ID do pedido ou método de pagamento"
                    layout='squired'
                    badgeIcon='searchDark'
                    badgePosition='left'
                    textIndent='8px'
                    style={{ marginTop: 0 }}
                    onChangeValue={handleSearch}
                />
            </SearchRow>

            <OrdersTable status={selectedTab} search={search} />
        </Wrapper>
    );
}

const Wrapper = styled.div`
    margin-top: 20px;
    background: ${colors.neutralLight};
    border: 1px solid ${colors.neutralDark};
    border-radius: 12px;
    overflow: hidden;
`;

const Tabs = styled(Row)`
    padding: 0 20px;
    overflow: auto;
    gap: 0;
    border-bottom: 1px solid ${colors.neutralDark};

    &::-webkit-scrollbar {
        display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
`;

const SearchRow = styled.div`
    padding: 12px 20px;
    border-bottom: 1px solid ${colors.neutralDark};
`;

const TabItem = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 14px 16px;
    border: none;
    border-bottom: 2px solid ${({ selected }) => selected ? colors.occasionalPurple : 'transparent'};
    background: transparent;
    color: ${({ selected }) => selected ? colors.nightDark : colors.night};
    font-weight: ${({ selected }) => selected ? '600' : '400'};
    cursor: pointer;
    white-space: nowrap;
    font-size: 14px;
    font-family: inherit;
    transition: all 0.2s ease;
    margin-bottom: -1px;

    &:hover {
        color: ${colors.nightDark};
        border-bottom-color: ${({ selected }) => selected ? colors.occasionalPurple : colors.nightLight};
    }

    &:focus-visible {
        outline: 2px solid ${colors.occasionalPurple};
        outline-offset: -2px;
    }
`;
